import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { SettingsMenuVerticalIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { RemoveContactModal } from 'features/contacts/modal/remove_contact_modal';
import { setSelectedContactDrawer, toggleContactDrawerOpen, setCurrentContact } from 'features/contacts/slice';
import { RestoreContactModal } from '../modal/restore_contact_modal';
const styledItemCss = "sil0h28";
const StyledItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(styledItemCss, props.className)} />);
const actionsCss = "ag4i2uh";
const Actions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionsCss, props.className)} />;
});
export const ActionsDropdown = ({
  contact,
  showRemove = true
}) => {
  const dispatch = useDispatch();
  const [toggle, Dropdown, isExpanded] = useDropdown();
  const editContact = () => {
    dispatch(setCurrentContact(contact));
    dispatch(setSelectedContactDrawer('EDIT_CONTACT_FORM'));
    if (showRemove) dispatch(toggleContactDrawerOpen());
  };
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [isRestoreModalOpen, setIsRestoreModalOpen] = useState(false);
  const onRemoveClick = () => {
    setIsRemoveModalOpen(true);
  };
  const onRestoreClick = () => {
    setIsRestoreModalOpen(true);
  };
  const onClose = () => {
    setIsRemoveModalOpen(false);
    setIsRestoreModalOpen(false);
  };
  return <>
      <Actions>
        <IconButton size="small" aria-expanded={isExpanded} title="Contact Actions Button" onClick={toggle}>
          <SettingsMenuVerticalIcon />
        </IconButton>
        <Dropdown>
          <ViewportDropdownMenu removeTopOffset>
            <StyledItem onClick={editContact}>
              {I18n.t('publisher.contacts.buttons.edit')}
            </StyledItem>
            {showRemove && contact.visible && <StyledItem onClick={onRemoveClick}>
                {I18n.t('publisher.contacts.buttons.remove')}
              </StyledItem>}
            {showRemove && !contact.visible && <StyledItem onClick={onRestoreClick}>
                {I18n.t('publisher.contacts.buttons.restore')}
              </StyledItem>}
          </ViewportDropdownMenu>
        </Dropdown>
      </Actions>
      <RemoveContactModal isModalOpen={isRemoveModalOpen} onClose={onClose} uuid={contact.uuid} name={contact.name} />
      <RestoreContactModal isModalOpen={isRestoreModalOpen} onClose={onClose} uuid={contact.uuid} name={contact.name} />
    </>;
};

require("./actions_dropdown.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./actions_dropdown.js");